import { configureStore } from "@reduxjs/toolkit";
import RootReducer from "./RootRouter";

export const store = configureStore({
  reducer: RootReducer,
});

export default store;
